export default function Welcome() {
  return (
    <div style={{ maxWidth: 480, margin: '48px auto', padding: 24 }}>
      <h1>Welcome 🎉</h1>
      <p>Your account is ready.</p>
      <p>
        <a href="/">Go to Dashboard</a>
      </p>
    </div>
  );
}
